import React from 'react';
import { Quote } from 'lucide-react';
import { testimonials } from '../data/constants';
export function Testimonials() {
  return <section className="py-16 md:py-20 px-4 max-w-6xl mx-auto" data-id="element-427">
      <div className="text-center mb-10 md:mb-14" data-id="element-428">
        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-429">
          ⭐ Prueba social
        </p>
        <h2 className="text-2xl md:text-4xl font-extrabold leading-tight max-w-3xl mx-auto" data-id="element-430">
          Más de 500 personas ya{' '}
          <span className="text-primary" data-id="element-431">arrancaron con la guía</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-4 md:gap-6" data-id="element-432">
        {testimonials.map((t, i) => <a key={i} href="#pricing" className="relative bg-surface border border-zinc-800 hover:border-primary/40 transition-colors p-6 md:p-7 rounded-2xl flex flex-col" data-id="element-433">
            <Quote className="absolute top-5 right-5 w-7 h-7 text-primary/15" data-id="element-434" />

            <div className="text-yellow-400 text-sm mb-4" data-id="element-435">⭐⭐⭐⭐⭐</div>

            <p className="text-zinc-200 italic text-base leading-relaxed mb-5 flex-grow" data-id="element-436">
              "{t.text}"
            </p>

            <div className="flex items-center gap-3 pt-4 border-t border-zinc-800/70" data-id="element-437">
              <div className="w-11 h-11 rounded-full bg-primary/10 border-2 border-primary/40 flex items-center justify-center font-space-grotesk font-bold text-sm text-primary shrink-0" data-id="element-438">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-439">
                <div className="font-bold text-white text-sm" data-id="element-440">{t.name}</div>
                <div className="text-xs text-zinc-500" data-id="element-441">
                  {t.role} · {t.location}
                </div>
              </div>
            </div>
          </a>)}
      </div>
    </section>;
}